<template>
  <div v-if="visible" class="help-backdrop" @click="closeOnBackdrop">
    <!-- <div class="help-box" @click.stop> -->
    <div class="help-box" :style="selected_style" @click.stop>
      <div class="help-header">
        <h3 class="help-title">{{ title }}</h3>
        <button class="help-close" @click="hide()">×</button>
      </div>

      <div class="help-body" v-html="content"></div>

      <div class="help-footer">
        <button class="help-btn" @click="hide()">Tamam</button>
      </div>
    </div>
  </div>
</template>

<script>
import { data as help_list } from '@/wam/options/help_list';

export default {
  name: "HelpPopup",
  data() {
    return {
      'visible': false,
      'title': 'Bilgi',
      'content': '',
      'selected_style': '',
    };
  },

  methods: {
    show(help_key, lang) {
      this.content = help_list[help_key][lang].content;
      this.title = help_list[help_key][lang].caption;
      this.selected_style = help_list[help_key][lang].style;
      this.visible = true;
    },
    // show(text, title = "Bilgi") {
    //   this.content = text;
    //   this.title = title;
    //   this.visible = true;
    // },
    hide() {
      this.visible = false;
    },
    closeOnBackdrop(e) {
      if (e.target === e.currentTarget) {
        this.hide();
      }
    },
  },
};
</script>

<style scoped>
/* (Aynı css yapısı – daha önce verdiğim gibi kısaltıyorum) */
.help-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 99999;

  /* 🔑 taşma güvenliği */
  overflow-y: auto;
  padding: 16px;
}

.help-box {
  /* ❌ min-width: 420px;  <-- SİL */
  
  width: min(90vw, 900px);
  max-height: 85vh;

  display: flex;
  flex-direction: column;

  background: white;
  border-radius: 14px;
  overflow: hidden;

  animation: fadeIn 0.2s ease;
}

.help-header {
  padding: 16px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;

  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-shrink: 0;
}

.help-body {
  padding: 18px 20px;
  font-size: 14px;
  line-height: 1.5;

  flex: 1;
  overflow-y: auto;
}

.help-footer {
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;

  display: flex;
  justify-content: flex-end;

  flex-shrink: 0;
}

.help-title { margin: 0; }

.help-close {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
}



.help-btn {
  background: #2563eb;
  color: white;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

@keyframes fadeIn {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>